// import  { useRef, useCallback } from 'react';
// import { getFileUrl } from '../../constants';

// const theme = {
//   custom: {
//     greyBackground: '#f0f0f0',
//   },
// };



// /**
//  * Extract YouTube video ID from URL
//  */
// const extractYouTubeId = (url) => {
//   if (!url) return '';
//   const regex =
//     /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([\w-]{11})/;
//   const match = url.match(regex);
//   return match ? match[1] : '';
// };

// const VideoPlayer = ({ url, height = 300, play = false }) => {
//   const playerRef = useRef(null);
//   const videoId = extractYouTubeId(url);
//   const isYouTube = Boolean(videoId);

//   const onReady = useCallback(() => {
 
//   }, []);

//   if (!url) return null;

//   return (
//     <div
//       style={{
//         width: '100%',
//         height,
//         borderRadius: 10,
//         overflow: 'hidden',
//         backgroundColor: theme.custom.greyBackground,
//       }}
//     >
//       {isYouTube ? (
//         <iframe
//           ref={playerRef}
//           width="100%"
//           height={height}
//           src={`https://www.youtube.com/embed/${videoId}?autoplay=${play ? 1 : 0}&controls=1`}
//           title="YouTube video"
//           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//           allowFullScreen
//           onLoad={onReady}
//           style={{ border: 0, borderRadius: 10 }}
//         />
//       ) : (
//         <video
//           ref={playerRef}
//           src={getFileUrl(url)}
//           controls
//           style={{ width: '100%', height: '100%', borderRadius: 10 }}
//           autoPlay={play}
//           muted={!play}
//         />
//       )}
//     </div>
//   );
// };

// export default VideoPlayer;

import { useRef, useCallback } from 'react';
import { getFileUrl } from '../../constants';

const theme = {
  custom: {
    greyBackground: '#f0f0f0',
  },
};

/**
 * Extract YouTube video ID from URL
 */
const extractYouTubeId = (url) => {
  if (!url) return '';

  const regex =
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([\w-]{11})/;

  const match = url.match(regex);

  return match ? match[1] : '';
};

/**
 * Check if URL is external
 */
const isExternalUrl = (url) => {
  return /^https?:\/\//i.test(url);
};

const VideoPlayer = ({ url, height = 300, play = false }) => {
  const playerRef = useRef(null);

  const videoId = extractYouTubeId(url);
  const isYouTube = Boolean(videoId);
  const isVimeo = url && url.includes('vimeo.com');

  const onReady = useCallback(() => {
    console.log('Video Ready');
  }, []);

  if (!url) return null;

  /**
   * Final video source
   * - External URL → use directly
   * - Local file → convert using getFileUrl()
   */
  const finalVideoUrl = isExternalUrl(url) ? url : getFileUrl(url);

  const renderPlayer = () => {
    if (isYouTube) {
      return (
        <iframe
          ref={playerRef}
          width="100%"
          height={height}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=${
            play ? 1 : 0
          }&controls=1`}
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          onLoad={onReady}
          style={{
            border: 0,
            borderRadius: 10,
          }}
        />
      );
    }

    if (isVimeo) {
      // Handle both standard vimeo.com and player.vimeo.com embed URLs
      let vimeoSrc = url;
      if (url.includes('player.vimeo.com/video/')) {
        const separator = url.includes('?') ? '&' : '?';
        vimeoSrc = `${url}${separator}autoplay=${play ? 1 : 0}`;
      } else {
        const match = url.match(/vimeo\.com\/(\d+)/);
        if (match) {
          vimeoSrc = `https://player.vimeo.com/video/${match[1]}?autoplay=${play ? 1 : 0}`;
        }
      }

      return (
        <iframe
          ref={playerRef}
          width="100%"
          height={height}
          src={vimeoSrc}
          title="Vimeo video"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          onLoad={onReady}
          style={{
            border: 0,
            borderRadius: 10,
          }}
        />
      );
    }

    return (
      <video
        ref={playerRef}
        src={finalVideoUrl}
        controls
        autoPlay={play}
        muted={!play}
        playsInline
        onCanPlay={onReady}
        style={{
          width: '100%',
          height: '100%',
          borderRadius: 10,
          objectFit: 'cover',
          backgroundColor: '#000',
        }}
      >
        Your browser does not support the video tag.
      </video>
    );
  };

  return (
    <div
      style={{
        width: '100%',
        height,
        borderRadius: 10,
        overflow: 'hidden',
        backgroundColor: theme.custom.greyBackground,
        position: 'relative',
      }}
    >
      {renderPlayer()}
    </div>
  );
};

export default VideoPlayer;